export const shows = [
	{
		id: "sunny",
		name: "It's Always Sunny in Philadelphia",
		color: "#FFD93D",
		logo: "/logos/ItsAlwaysSunnyInPhiladelphia.svg",
	},
	{
		id: "office_us",
		name: "The Office (US)",
		color: "#A7C7E7",
		logo: "/logos/TheOffice.svg",
	},
	{
		id: "brooklyn_99",
		name: "Brooklyn Nine-Nine",
		color: "#5B8FFF",
		logo: "/logos/BrooklynNineNine.png",
	},
	{
		id: "30_rock",
		name: "30 Rock",
		color: "#C4A6E8",
		logo: "/logos/30Rock.svg",
	},
	{
		id: "ted_lasso",
		name: "Ted Lasso",
		color: "#FF6B6B",
		logo: "/logos/TedLasso.webp",
	},
	{
		id: "new_girl",
		name: "New Girl",
		color: "#FFB5C2",
		logo: "/logos/NewGirl.svg",
	},
	{
		id: "parks_and_rec",
		name: "Parks and Recreation",
		color: "#90D4A3",
		logo: "/logos/ParksAndRec.png",
	},
	{
		id: "top_gear",
		name: "Top Gear",
		color: "#FFB347",
		logo: "/logos/TopGear.svg",
	},
	{
		id: "thegrandtour",
		name: "The Grand Tour",
		color: "#FFB347",
		logo: "/logos/TheGrandTour.svg",
	},
	{
		id: "top_gear+thegrandtour",
		name: "Top Gear + Grand Tour",
		color: "#FFB347",
		logo: "/logos/TopTour.svg",
	},
];

export const loadingImages = [
	{
		id: "sunny",
		url: "/images/sunny.png",
		name: "It's Always Sunny in Philadelphia",
	},
	{
		id: "office_us",
		url: "/images/office_us.png",
		name: "The Office (US)",
	},
	{
		id: "brooklyn_99",
		url: "/images/brooklyn_99.png",
		name: "Brooklyn Nine-Nine",
	},
	{ id: "30_rock", url: "/images/30_rock.png", name: "30 Rock" },
	{
		id: "ted_lasso",
		url: "/images/ted_lasso.png",
		name: "Ted Lasso",
	},
	{ id: "new_girl", url: "/images/new_girl.png", name: "New Girl" },
	{
		id: "parks_and_rec",
		url: "/images/parks_and_rec.png",
		name: "Parks and Recreation",
	},
	{ id: "top_gear", url: "/images/top_gear.png", name: "Top Gear" },
	{
		id: "thegrandtour",
		url: "/images/top_gear.png",
		name: "The Grand Tour",
	},
	{
		id: "top_gear+thegrandtour",
		url: "/images/top_gear.png",
		name: "Top Gear + Grand Tour",
	},
];
